import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const RefundIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      fill="none"
      {...props}
    >
      <rect width={36} height={36} fill={theme.palette.grey[100]} rx={18} />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="M11.354 17.542v-3.438c0-.506.41-.916.917-.916h12.375c.506 0 .916.41.916.916v7.792c0 .506-.41.916-.916.916h-6.188M12.958 19.604l-3.143 3.144a.092.092 0 0 0 0 .13l3.143 3.143M9.75 22.812h5.958"
      />
      <circle
        cx={1.604}
        cy={1.604}
        r={1.604}
        stroke={theme.palette.common.black}
        strokeWidth={1.25}
        transform="matrix(-1 0 0 1 20.063 16.396)"
      />
    </svg>
  );
};
